<template>
  <router-view>
  </router-view>
</template>

<script>
import {mapGetters} from "vuex";
import {getPermissions} from "@/app/domains/Auth/store/getters";
import {isNull} from "lodash";

export default {
  name: 'mainDomains',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('Auth', ['getPermissions', 'currentUser', 'getColorTheme']),
    btnStyles() {
      return `
      :root {
        --primary-color: ${this.getColorTheme.colorPrimary};
        --secondary-color: ${this.getColorTheme.colorSecondary};
      }
      `
    }
  },
  watch: {
    'getPermissions': function (params) {
      // this.setTheme()
      this.$setTheme({
        colorPrimary: this.getColorTheme.colorPrimary,
        colorSecondary: this.getColorTheme.colorSecondary,
      })
    }
  },
  methods: {
    // setTheme () {
    //   
    //   if (!isNull(document.getElementById('rootCSS'))) {
    //     document.getElementById('rootCSS').remove()
    //   }
    //   let e = document.createElement('style');
    //   const css = document.createTextNode(this.btnStyles)
    //   e.setAttribute('type', 'text/css');
    //   e.setAttribute('id', 'rootCSS');
    //   e.appendChild(css)
    //   // document.getElementsByTagName('head').appendChild(e);
    //   document.getElementsByTagName('head')[0].append(e)
    // }
  },
  mounted() {
    // this.setTheme()
    this.$setTheme({
      colorPrimary: this.getColorTheme.colorPrimary,
      colorSecondary: this.getColorTheme.colorSecondary,
    })
  }
}
</script>
